
import {ReactComponent as VeryBadIcon} from '../../../assets/img/icons/rating/verybad.svg';
import {ReactComponent as BadIcon} from '../../../assets/img/icons/rating/bad.svg';
import {ReactComponent as AverageIcon} from '../../../assets/img/icons/rating/average.svg';
import {ReactComponent as GoodIcon} from '../../../assets/img/icons/rating/good.svg';
import {ReactComponent as VeryGoodIcon} from '../../../assets/img/icons/rating/verygood.svg';
import { useTranslation } from "react-i18next";

function RateButton({selected, onClick, rating}) {
  return (<div className="flex flex-row md:flex-col gap-x-2">
    <button
      className={`flex flex-col w-[5.25rem] h-[3.375rem] md:w-[6.25rem] md:h-[4.375rem] rounded-[0.625rem] hover:border hover:border-playmove-mediumblue ${selected ? 'bg-playmove-mediumblue' : 'bg-playmove-lightblue'}`}
      onClick={onClick}
    >        
      <rating.icon className={`m-auto w-8 md:w-auto ${selected ? "fill-white" : "fill-playmove-blue"}`}/>
    </button>
    <span className="self-center md:self-auto md:my-0 mt-2 font-bold text-playmove-lightgray">{rating.name}</span>
    </div>
  );
}

export default function RatingCategory({ value, onChange, category }) {
    const { t } = useTranslation();

    const ratings = [
        { name: t("bad"), icon: VeryBadIcon },
        { name: t("poor"), icon: BadIcon },
        { name: t("average"), icon: AverageIcon },
        { name: t("good"), icon: GoodIcon },
        { name: t("veryGood"), icon: VeryGoodIcon }
    ];

    return (
        <div className="h-full flex flex-col">
            <p className="text-left text-lg font-bold text-playmove-darkgray">{category}</p>
            <div className="mt-[1rem] flex flex-col-reverse md:flex-row gap-x-[2.5rem] gap-y-[1rem] place-content-around">
                {ratings.map((rating, index) => (
                    <RateButton
                        key={index}
                        selected={value === index + 1}
                        onClick={() => onChange(index + 1)}
                        rating={rating}
                    />
                ))}
            </div>
        </div>
    );
}